import React from 'react';

const SectionTopBanners = ({ places = [], onSelectPlace }) => {
  if (!places.length) return null;

  return (
    <div className="container col-md-8 col-lg-6 p-0">
      <div className="d-flex overflow-auto">
        {places.map((place) => (
          <div 
            key={place.id}
            className="ml-2 mt-2"
            style={{ width: '130px', flex: '0 0 auto' }}
            onClick={() => onSelectPlace && onSelectPlace(place.id)}
            role="button"
          >
            <div style={{ position: 'relative', paddingBottom: '100%', borderRadius: '8px', overflow: 'hidden' }}>
              <img src={place.image_data_medium || place.image_data || '/assets2019/img/icon_camera.svg'} alt={place.name} style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}/>
            </div>
            <p className="mt-2 mb-2 font-weight-bold" style={{ fontSize: '13px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
              {place.name}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionTopBanners;
